const ObjectValues = (myObject) => {
  if ("values" in Object) {
    return Object.values(myObject)
  }

  const values = []

  for (const key in myObject) {
    values.push(myObject[key])
  }

  return values
}

export default ObjectValues